import { render, staticRenderFns } from "./ParentHomePage.vue?vue&type=template&id=c71bfe62&"
import script from "./ParentHomePage.vue?vue&type=script&lang=js&"
export * from "./ParentHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c71bfe62')) {
      api.createRecord('c71bfe62', component.options)
    } else {
      api.reload('c71bfe62', component.options)
    }
    module.hot.accept("./ParentHomePage.vue?vue&type=template&id=c71bfe62&", function () {
      api.rerender('c71bfe62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ParentHomePage.vue"
export default component.exports